/* eslint-disable react/prop-types */
import { IoPaperPlaneOutline } from "react-icons/io5";
import "./styles.css";
import { IoIosTimer } from "react-icons/io";
import { FaRegCheckCircle } from "react-icons/fa";
import ModalDetailsMotivo from "./components/ModalDetailsMotivo/ModalDetailsMotivo";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";

function StatusCard({ status, motivo }) {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const isReprovado = status === "Não Aprovado";
  const isAprovado = status === "Aprovado";

  function reloadPage() {
    window.location.reload();
  }

  return (
    <>
      <div className="cardContent">
        <h2 className="statusTitle">Status da conta</h2>

        <div
          className="statusBadge"
          style={{
            backgroundColor: isReprovado ? "#ff4d4d" : "#d5de00",
            color: isReprovado ? "#fff" : "#000",
          }}
        >
          {isReprovado ? "Não Aprovado" : "Análise"}
        </div>

        <div className="statusSteps">
          {/* Etapa 1: Enviado (sempre ativa) */}
          <div className="step active">
            <div className="icon" style={{ paddingTop: 3, paddingRight: 3 }}>
              <IoPaperPlaneOutline />
            </div>
            <span>Enviado</span>
          </div>

          {/* Linha 1 */}
          <div className="line active" />

          {/* Etapa 2: Análise (ativa sempre) */}
          <div className="step active">
            <div className="icon">
              <IoIosTimer />
            </div>
            <span>Análise</span>
          </div>

          {/* Linha 2 */}
          <div
            className={`line ${isAprovado || isReprovado ? "active" : ""}`}
            style={isReprovado ? { backgroundColor: "#ff4d4d" } : {}}
          />

          {/* Etapa 3: Aprovado (ou Não Aprovado) */}
          <div className={`step ${isAprovado || isReprovado ? "active" : ""}`}>
            <div
              className="icon"
              style={
                isReprovado ? { backgroundColor: "#ff4d4d", color: "#fff" } : {}
              }
            >
              <FaRegCheckCircle />
            </div>
            <span>{isReprovado ? "Não aprovado" : "Aprovado"}</span>
          </div>
        </div>

        {isReprovado && (
          <div className="motivoContainer">
            <strong>Motivo de reprovação: </strong>
            <p> {motivo?.titulo}</p>
            <div className="motivoButtons">
              <Button
                color="success"
                onClick={() => navigate("/atualizar-dados")}
              >
                Atualizar dados
              </Button>

              <Button
                color="secondary"
                outline
                onClick={() => setShowModal(true)}
                style={{ color: "black" }}
              >
                Ver detalhes
              </Button>
            </div>
          </div>
        )}

        <button className="statusButton" onClick={reloadPage}>
          Verificar status novamente
        </button>
      </div>
      <ModalDetailsMotivo
        descricao={motivo?.descricao}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
}

export default StatusCard;
